<script setup>
import { ref, onMounted, watch, reactive, computed } from "vue"
import { useConfigStore } from '@/stores/useConfigStore.js'
import Header from "@/components/Header.vue";
import TextInput from "@/components/TextInput.vue";
import Icon from "@/components/Icon.vue";
import ModalShow from "@/components/ModalShow.vue";
import SearchSelectComponent from "@/components/SearchSelectComponent.vue";
import api, { customApi, baseURL} from "@/libs/api.js";
import EventBus from "@/libs/eventBus";
const form = ref({
    name: '',
    members : []
});
const useConfig = useConfigStore();
const loading = ref(false);
const showAdd = ref(false);
const members = ref({})
const errors = ref({})

onMounted(() => {
    getDetail()
})
const formattedBirthday = computed({
    get: () => {
        if (!form.value.birthday) return "";

        const datePart = form.value.birthday.includes("T") 
          ? form.value.birthday.split("T")[0]  
          : form.value.birthday.split(" ")[0]; 

        return datePart;
    },
    set: (newValue) => {
        if (newValue) {
          form.value.birthday = `${newValue}T00:00:00+00:00`;
        }
    }
});

const showLoading = () => {
    showAdd.value = false
    form.value.members.push(members.value)
    members.value = {}
};

const showModal = () => {
    showAdd.value = true;
};

const hideModal = () => {
    showAdd.value = false;
};
const gender = ref([
    {
        'id' : 1,
        'name' : 'Nam'
    },
    {
        'id' : 2,
        'name' : 'Nữ'
    },
    {
        'id' : 3,
        'name' : 'Khác'
    },
])
const handleDelete = (k) => {
     form.value.members.splice(k, 1);
}
const getDetail = () => {
    api.get('/residence-information/'+ useConfig.user.id).then((response) => {
        let data = response.data.data
        if(data){
            form.value.authority = data.authority
            form.value.name = data.name
            form.value.birthday = data.birthday
            form.value.gender = data.gender
            form.value.id_number = data.id_number
            form.value.tenant_id = data.tenant_id
            form.value.email = data.email
            form.value.phone = data.phone
            form.value.address = data.address
            form.value.temporary_address = data.temporary_address
            form.value.current_address = data.current_address
            form.value.job = data.job
            form.value.host_name = data.job
            form.value.host_relation = data.host_relation
            form.value.host_id_number = data.host_id_number
            form.value.note = data.note
            form.value.members = data.members
        }else{
           
            form.value.tenant_id = useConfig.user.id
            form.value.name = useConfig.user.name
            if(useConfig.user.information){
                form.value.birthday = useConfig.user.information.birthday
                form.value.gender = useConfig.user.information.gender
                form.value.id_number = useConfig.user.information.idNumber
            }
            form.value.email = useConfig.user.email
            form.value.phone = useConfig.user.phone
            form.value.address = useConfig.user.address
        }

    })
}

const formatDate = (input) => {
    if(!loading.value){
        if (typeof input === "string" && input.includes("T")) {
            return input.split("T")[0]; // Nếu là chuỗi có "T", cắt bỏ phần giờ
        }
        return input; 
    }
};
const isISO8601 = (input) => {
    const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return iso8601Regex.test(input);
};
const submit = () => {
    loading.value = true;
    form.value.members.map(item => {
        if(!isISO8601(item.birthday)){
            item.birthday  = new Date(item.birthday + "T17:00:00.000Z");
        }
    })

    api.put('/residence-information/'+ useConfig.user.id,form.value).then((response) => {
        EventBus.emit('show-notification', JSON.stringify({
            id: '',
            title: "Thông báo!",
            message: response.data.message,
            url: '',
            type: 'success',
            showtime: 2000
        }));
         loading.value = false;
         getDetail()
    }).catch((error) => {
        if (error.status === 422) {
            errors.value = error.data.errors;

        }
        loading.value = false
    });
  
}
</script>
<template>
    <div class="w-full h-full animation_page overflow-auto">
        <Header text="kê khai tạm trú" :url="{ name: 'user' }"></Header>
        <div class="w-full h-auto pt-14">
            <div class="pb-4 bg-white h-auto divide-y px-6">
                <div class="w-full pt-4">
                    <TextInput label="Cơ quan đăng ký cư trú <span class='text-red-600'>*</span>" type="text" id="authority" v-model="form.authority" />
                    <p v-if="errors && errors.authority" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.authority }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Họ, chữ đệm và tên <span class='text-red-600'>*</span>" type="text" id="name" v-model="form.name" />
                    <p v-if="errors && errors.name" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.name }}
                    </p>
                </div>
                <div class="w-full flex gap-4">
                    <div class="w-full pt-4">
                        <label for="birthday" class="font-semibold ">
                            Ngày sinh
                            <span class="text-red-600">*</span>
                        </label>
                        <input type="date" class="mt-2 placeholder-transition bg-white border border-gray-300 text-gray-900 rounded-lg focus:ring-main focus:border-main block w-full pe-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-main dark:focus:border-main caret-transparent" name="birthday" id="birthday" v-model="formattedBirthday">
                        <p v-if="errors && errors.birthday" class="text-red-600 text-sm mt-1 px-4">
                            {{ errors.birthday }}
                        </p>
                    </div>
                    <div class="w-full pt-4">
                        <label for="gender" class="font-semibold">
                            Giới tính
                            <span class="text-red-600">*</span>
                        </label>
                        <SearchSelectComponent class="mt-2" :data="gender" placeholder="Giới tính" :teleport="true" v-model:id="form.gender" h=""></SearchSelectComponent>
                        <p v-if="errors && errors.gender" class="text-red-600 text-sm mt-1 px-4">
                            {{ errors.gender }}
                        </p>
                    </div>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Số định danh cá nhân, CMND/CCCD <span class='text-red-600'>*</span>" type="text" id="id_number" v-model="form.id_number" />
                    <p v-if="errors && errors.id_number" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.id_number }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Số điện thoại <span class='text-red-600'>*</span>" type="text" id="phone" v-model="form.phone" />
                    <p v-if="errors && errors.phone" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.phone }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Email"  type="email" id="email" v-model="form.email" />
                    <p v-if="errors && errors.email" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.email }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Nơi thường trú <span class='text-red-600'>*</span>" type="text" id="address" v-model="form.address" />
                    <p v-if="errors && errors.address" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.address }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Nơi tạm trú <span class='text-red-600'>*</span>" type="text" id="temporary_address" v-model="form.temporary_address" />
                    <p v-if="errors && errors.temporary_address" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.temporary_address }}
                    </p>
                </div>
                 <div class="w-full pt-4">
                    <TextInput label="Nơi ở hiện nay <span class='text-red-600'>*</span>" type="text" id="current_address" v-model="form.current_address" />
                    <p v-if="errors && errors.current_address" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.current_address }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Nghề nghiệp, nơi làm việc <span class='text-red-600'>*</span>" type="text" id="job" v-model="form.job" />
                    <p v-if="errors && errors.job" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.job }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Họ, chữ đệm và tên chủ hộ <span class='text-red-600'>*</span>" type="text" id="host_name" v-model="form.host_name" />
                    <p v-if="errors && errors.host_name" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.host_name }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Quan hệ với chủ hộ <span class='text-red-600'>*</span>" type="text" id="host_relation" v-model="form.host_relation" />
                    <p v-if="errors && errors.host_relation" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.host_relation }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <TextInput label="Số định danh cá nhân, số CMND/CCCD của chủ hộ <span class='text-red-600'>*</span>" type="text" id="host_id_number" v-model="form.host_id_number" />
                    <p v-if="errors && errors.host_id_number" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.host_id_number }}
                    </p>
                </div>
                <div class="w-full pt-4">
                    <label for="note" class="font-semibold">
                        Nội dung đề nghị
                    </label>
                    <textarea v-model="form.note" type="text" id="note" rows="4"
                        class="w-full mt-1 border border-gray-300 rounded-md px-4 py-3 focus:border-main focus:ring-main"
                        placeholder="Nội dung đề nghị..."></textarea>
                    <p v-if="errors && errors.note" class="text-red-600 text-sm mt-1 px-4">
                        {{ errors.note }}
                    </p>
                </div>
            </div>
            <div class="pb-4 bg-white h-auto px-6">
                <div @click="showModal" class="w-full pb-4 flex justify-between items-center">
                    <div class="font-semibold">
                        Thành viên gia đình
                    </div>
                    <button class="px-5 py-1 bg-main rounded shadow text-white ">
                        Thêm
                    </button>
                </div>
                <div class="w-full relative border rounded shadow-sm p-4" v-for="(item,key) in form.members" :key="key">
                    <div class="w-full flex justify-between font-bold pb-2">
                        <p>Họ tên: {{item.name}}</p>
                        <Icon @click="handleDelete(key)" name="trash" class="w-5 h-5 fill-red-500 mr-2"/>
                    </div>
                    <p class="font-bold pb-2">Ngày sinh: {{formatDate(item.birthday)}}</p>
                    <p class="font-bold pb-2">Giới tính: {{item.gender}}</p>
                    <p class="font-bold pb-2">Số định danh cá nhân, CMND: {{item.idNumber}}</p>
                    <p class="font-bold pb-2">Nghề nghiệp, noi làm việc: {{item.job}}</p>
                    <p class="font-bold pb-2">Quan hệ với chủ hộ: {{item.relation}}</p>
                </div>
                <div class="w-full py-8 flex justify-center items-center">
                    <button v-if="loading === false" @click="submit" type="button"
                        class="w-full font-bold text-center py-4 bg-main text-white rounded shadow"
                        :class="{ 'animation_width': loading === true }">
                        Xác nhận
                    </button>
                    <div v-else class="w-16 h-16 bg-main text-white rounded-full flex justify-center items-center">
                        <svg class="w-14 h-14 fill-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                            height="512" viewBox="0 0 24 24" width="512">
                            <path
                                d="m12 22c-5.51 0-10-4.49-10-10 0-1.87.52-3.69 1.5-5.27.29-.47.91-.61 1.38-.32s.61.90999.32 1.37999c-.78 1.26-1.2 2.72001-1.2 4.21001 0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10z" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalShow :show="showAdd" title="Thêm thành viên" @call-back="hideModal">
        <div class="w-full pt-4 px-6">
            <TextInput label="Họ, chữ đệm và tên <span class='text-red-600'>*</span>" type="text" id="members_name" v-model="members.name" />
            <p v-if="errors && errors.name" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.name }}
            </p>
        </div>
        <div class="w-full flex gap-4 px-6">
            <div class="w-full pt-4">
                <label for="members_birthday" class="font-semibold">
                    Ngày sinh
                    <span class="text-red-600">*</span>
                </label>
                <input type="date" class="mt-2 placeholder-transition bg-white border border-gray-300 text-gray-900 rounded-lg focus:ring-main focus:border-main block w-full pe-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-main dark:focus:border-main caret-transparent" name="members_birthday" id="members_birthday" v-model="members.birthday">
                <p v-if="errors && errors.birthday" class="text-red-600 text-sm mt-1 px-4">
                    {{ errors.birthday }}
                </p>
            </div>
            <div class="relative    w-full pt-4">
                <label for="members_gender" class="font-semibold ">
                    Giới tính
                    <span class="text-red-600">*</span>
                </label>
                <SearchSelectComponent class="mt-2" uid="members_gender" :data="gender" placeholder="Giới tính" :teleport="true" v-model:id="members.gender" h=""></SearchSelectComponent>
                <p v-if="errors && errors.gender" class="text-red-600 text-sm mt-1 px-4">
                    {{ errors.gender }}
                </p>
            </div>
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Số định danh cá nhân, CMND" type="text" id="members_idNumber" v-model="members.idNumber" />
            <p v-if="errors && errors.idNumber" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.idNumber }}
            </p>
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Nghề nghiệp, nơi làm việc <span class='text-red-600'>*</span>" type="text" id="members_job" v-model="members.job" />
            <p v-if="errors && errors.job" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.job }}
            </p>
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Quan hệ với chủ hộ <span class='text-red-600'>*</span>" type="text" id="members_relation" v-model="members.relation" />
            <p v-if="errors && errors.relation" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.relation }}
            </p>
        </div>
        <div class="w-full pt-12 pb-8 px-6 flex justify-center items-center">
            <button v-if="loading === false" @click="showLoading" type="button"
                class="w-full font-bold text-center py-4 bg-main text-white rounded shadow"
                :class="{ 'animation_width': loading === true }">
                Xác nhận
            </button>
            <div v-else class="w-16 h-16 bg-main text-white rounded-full flex justify-center items-center">
                <svg class="w-14 h-14 fill-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                    height="512" viewBox="0 0 24 24" width="512">
                    <path
                        d="m12 22c-5.51 0-10-4.49-10-10 0-1.87.52-3.69 1.5-5.27.29-.47.91-.61 1.38-.32s.61.90999.32 1.37999c-.78 1.26-1.2 2.72001-1.2 4.21001 0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10z" />
                </svg>
            </div>
        </div>
    </ModalShow>
</template>
<style scoped>
.animation_width {
    animation: width 150ms linear;
}

@keyframes width {
    0% {
        width: 100%;
        opacity: 1;
    }

    100% {
        width: 0px;
        opacity: 0;
    }
}
</style>